<template lang="pug">
  .me
    sys-bar(:backable="true" ref="sysBar")
    .content(ref="content")
      transition-slide
        router-view
</template>

<script>
import SysBar from '@/components/SysBar'
import { mapState, mapMutations, mapActions } from 'vuex'
import TransitionSlide from '@/components/TransitionSlide'
export default {
  name: 'Me',
  components: { TransitionSlide, SysBar },
  computed: {
    ...mapState('app', ['router', 'user']),
  },
  methods: {
    ...mapMutations('app', ['setRouterBack', 'setPending']),
    ...mapActions('app', ['GetUser']),
    fetchUserInfo() {
      this.setPending(true)
      this.GetUser(this.user.id)
        .then(() => {
          this.setPending(false)
        })
        .catch((err) => {
          console.log(err)
          this.setPending(false)
        })
    },
  },
  created() {
    this.fetchUserInfo()
  },
  watch: {
    $route(val) {
      console.log(val)
      if (val.path.indexOf('/me') === -1) return
      if (val.path === '/me/main') this.setRouterBack('/')
      if (
        val.path === '/me/fam' ||
        val.path === '/me/res' ||
        val.path === '/me/footprint'
      )
        this.setRouterBack('/me/main')
      this.fetchUserInfo()
    },
  },
  mounted() {
    this.$refs.content.style.height =
      window.innerHeight -
      this.$refs.sysBar.$el.getBoundingClientRect().height +
      'px'
  },
}
</script>

<style scoped lang="sass">
@import "../../styles/common"
.me
  background: #ffffff
  .content
    position: relative

.slide-enter, .slide-leave-to
  transform: translateX(100%)
</style>
